import { Drawer, EmptyState } from "procurement/design"
import { useGetPurchaseGoodsReceiptsQuery } from "shared/redux/endpoints/procurementGrn"
import { Loading } from "../../ui"
import { formatDateTime } from "../../constants"
import { QUALITY_LABEL } from "../../receiptStatus"

const EVENT_LABEL = {
  rejected: "Delivery rejected",
  procurement_receive: "Received by procurement",
  completed: "PO completed",
}

const ReceiptEntry = ({ entry }) => {
  const isReceipt = entry.kind === "receipt"
  return (
    <div style={{ border: "1px solid var(--border)", borderRadius: 10, padding: "10px 12px" }}>
      <div style={{ display: "flex", justifyContent: "space-between", gap: 8, alignItems: "center" }}>
        <strong style={{ fontSize: 13 }}>{isReceipt ? entry.grnCode : EVENT_LABEL[entry.kind] || entry.kind}</strong>
        <span style={{ fontSize: 12, color: "var(--text-muted)" }}>{formatDateTime(entry.receivedAt)}</span>
      </div>
      {(entry.receivedBy?.name || entry.note) && (
        <div style={{ fontSize: 12, color: "var(--text-secondary)", marginTop: 4 }}>
          {[entry.receivedBy?.name, entry.note].filter(Boolean).join(" — ")}
        </div>
      )}
      {isReceipt && (entry.lines || []).length > 0 && (
        <div style={{ display: "grid", gap: 6, marginTop: 8 }}>
          {entry.lines.map((l) => (
            <div
              key={`${l.orderRequestLineId}-${l.itemId ?? ""}`}
              style={{ display: "flex", justifyContent: "space-between", gap: 8, fontSize: 13 }}
            >
              <div style={{ minWidth: 0 }}>
                <div style={{ overflowWrap: "anywhere" }}>{l.itemName || "—"}</div>
                <div style={{ fontSize: 12, color: "var(--text-muted)" }}>
                  {[l.orderCode, l.qualityStatus && QUALITY_LABEL[l.qualityStatus], l.qualityNote]
                    .filter(Boolean)
                    .join(" · ")}
                </div>
              </div>
              <div style={{ flexShrink: 0, textAlign: "right" }}>
                <strong>{l.receivedQty}</strong>
                {l.orderedQty != null && <span style={{ color: "var(--text-muted)" }}> / {l.orderedQty}</span>}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

// Receipt history of one PO. Each batch's quantity is its own, not a running
// total — the per-line totals live in the PO's receiptProgress.
const GoodsReceiptHistoryDrawer = ({ purchaseId, poCode, open, onClose }) => {
  const { data, isFetching } = useGetPurchaseGoodsReceiptsQuery(purchaseId, { skip: !open || !purchaseId })
  const entries = Array.isArray(data) ? data : []
  return (
    <Drawer open={open} onClose={onClose} title={poCode ? `Receipt history · ${poCode}` : "Receipt history"}>
      {isFetching && !entries.length && <Loading />}
      {!isFetching && entries.length === 0 && <EmptyState title="No goods receipt recorded yet" />}
      <div style={{ display: "grid", gap: 10 }}>
        {entries.map((e) => (
          <ReceiptEntry key={e.key} entry={e} />
        ))}
      </div>
    </Drawer>
  )
}

export default GoodsReceiptHistoryDrawer
